import axios from "axios";
// import {EventBus} from "@/event-bus";
import {EventBus} from "@/event-bus";
import FileDownload from 'js-file-download';
import {clientMessage, isKnownClientCode} from '@/intake/clientMessages';
import {rememberRateLimit, rateLimitMessage, requestLanguage} from '@/intake/requestRateLimit';


const baseUrl = process.env.VUE_APP_BASE_URL

function resolveUrl(path) {
    if (!path) {
        return path
    }
    if (/^https?:\/\//i.test(path)) {
        return path
    }
    return baseUrl + path
}

function postFailureMessage(body, error) {
    const limited = rateLimitMessage(error, requestLanguage())
    if (limited) return limited
    const code = body && ((body.data && (body.data.reason_code || body.data.code)) || body.reason_code || body.code || body.message)
    if (isKnownClientCode(code)) {
        return clientMessage(code, requestLanguage())
    }
    return body && body.message
}

/*eslint-disable*/
export function ajaxGet(path, payload, header, notif) {
    if (path) {
        header.Authorization = 'Bearer ' + localStorage.getItem('token')
        return new Promise((resolve, reject) => {
            axios.get(resolveUrl(path), {
                // withCredentials: true,
                headers: header
            }).then((resp) => {
                resolve(resp.data)
            }).catch((er) => {
                rememberRateLimit(er)
                reject(er)
            })
        })
    }
}

export function ajaxDelete(path, payload = {}, header = {}, notif) {
    if (path) {
        header.Authorization = 'Bearer ' + localStorage.getItem('token')
        return new Promise((resolve, reject) => {
            axios.delete(resolveUrl(path), {headers: header, data: payload}).then((resp) => {
                resolve(resp.data)
            }).catch((er) => {
                rememberRateLimit(er)
                reject(er)
            })
        })
    }
}

export function ajaxPost(path, payload, header = {}, notif) {
    if (path) {
        header.Authorization = 'Bearer ' + localStorage.getItem('token')
        return new Promise((resolve, reject) => {
            axios.post(resolveUrl(path), payload, {
                headers: header
            }).then((resp) => {
                resolve(resp.data)
            }).catch(er => {
                rememberRateLimit(er)
                if (er.response && er.response.hasOwnProperty('data')) {
                    EventBus.$emitEvent('notify', ({title: postFailureMessage(er.response.data, er), color: 'red', id: 'notify'}))
                }
                reject(er)
            })
        })
    }
}

export function ajaxPut(path, payload, header = {}, notif) {
    if (path) {
        header.Authorization = 'Bearer ' + localStorage.getItem('token')
        return new Promise((resolve, reject) => {
            axios.put(resolveUrl(path), payload, {
                headers: header
            }).then((resp) => {
                resolve(resp.data)
            }).catch(er => {
                rememberRateLimit(er)
                if (er.response && er.response.hasOwnProperty('data')) {
                    EventBus.$emitEvent('notify', ({title: postFailureMessage(er.response.data, er), color: 'red', id: 'notify'}))
                }
                reject(er)
            })
        })
    }
}

export function ajaxDownload(path, payload, header, notif) {
    if (path) {
        try {
            return new Promise((resolve, reject) => {
                axios.get(resolveUrl(path), {
                    withCredentials: true,
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('token'),
                    },
                    responseType: 'blob'
                }).then(resp => {
                    FileDownload(resp.data, 'file.' + payload.type);
                    resolve();
                }).catch((err) => {
                    // store.commit('setLoading', false);
                    EventBus.$emitEvent('notify', ({title: er.response.data.message, color: 'red', id: 'test '}))
                    reject(err);
                }).finally(() => {
                });
            });
        } catch (err) {
            // EventBus.$emit('notify', 'red', undefined, this.$t('$vuetify.Notify.error'));
            // store.commit('setLoading', false);
        }
    }
}

let httpUtilities = {
    get: ajaxGet,
    post: ajaxPost,
    put: ajaxPut,
    delete: ajaxDelete,
    download: ajaxDownload,
}
export default httpUtilities
